module.exports = __webpack_public_path__ + "img/PT7210.a7fceb78.png";